import e from "react";
import n from "@appchoose/cn";
import s from "@appchoose/icon";
import * as t from "@radix-ui/react-select";
const N = t.Root, h = t.Group, x = t.Value, m = e.forwardRef(({ className: r, children: l, ...a }, o) => /* @__PURE__ */ e.createElement(
  t.Trigger,
  {
    ref: o,
    className: n(
      "flex h-10 w-full items-center justify-between rounded border border-gray-500 px-3 py-2 text-sm text-gray-900 disabled:cursor-not-allowed disabled:border-gray-100 disabled:bg-gray-50 disabled:text-gray-500 data-[placeholder]:text-gray-500 disabled:data-[placeholder]:text-gray-300 [&>span]:truncate",
      !a.disabled && 'group border-gray-500 transition duration-300 hover:border-gray-700 focus:border-gray-700 focus:ring-1 focus:ring-inset focus:ring-gray-700 aria-[invalid="true"]:border-red-600 aria-[invalid="true"]:ring-red-600 data-[state=open]:border-gray-700 data-[state=open]:ring-1 data-[state=open]:ring-inset data-[state=open]:ring-gray-700 aria-[invalid="true"]:data-[state=open]:border-red-600 aria-[invalid="true"]:data-[state=open]:ring-red-600',
      r
    ),
    ...a
  },
  l,
  /* @__PURE__ */ e.createElement(t.Icon, { asChild: !0 }, /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    s,
    {
      icon: "arrowDown",
      className: "shrink-0 group-data-[state=open]:hidden"
    }
  ), /* @__PURE__ */ e.createElement(
    s,
    {
      icon: "close",
      className: "shrink-0 group-data-[state=closed]:hidden"
    }
  )))
));
m.displayName = t.Trigger.displayName;
const d = e.forwardRef(({ className: r, ...l }, a) => /* @__PURE__ */ e.createElement(
  t.ScrollUpButton,
  {
    ref: a,
    className: n(
      "flex cursor-default items-center justify-center py-1",
      r
    ),
    ...l
  },
  /* @__PURE__ */ e.createElement(s, { icon: "arrowUp", className: "shrink-0" })
));
d.displayName = t.ScrollUpButton.displayName;
const c = e.forwardRef(({ className: r, ...l }, a) => /* @__PURE__ */ e.createElement(
  t.ScrollDownButton,
  {
    ref: a,
    className: n(
      "flex cursor-default items-center justify-center py-1",
      r
    ),
    ...l
  },
  /* @__PURE__ */ e.createElement(s, { icon: "arrowDown", className: "shrink-0" })
));
c.displayName = t.ScrollDownButton.displayName;
const p = e.forwardRef(({ className: r, children: l, position: a = "popper", ...o }, i) => /* @__PURE__ */ e.createElement(t.Portal, null, /* @__PURE__ */ e.createElement(
  t.Content,
  {
    ref: i,
    className: n(
      "relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-md border bg-white shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
      r
    ),
    position: a,
    sideOffset: 4,
    ...o
  },
  /* @__PURE__ */ e.createElement(d, null),
  /* @__PURE__ */ e.createElement(
    t.Viewport,
    {
      className: n(
        "p-1",
        a === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
      )
    },
    l
  ),
  /* @__PURE__ */ e.createElement(c, null)
)));
p.displayName = t.Content.displayName;
const u = e.forwardRef(({ className: r, ...l }, a) => /* @__PURE__ */ e.createElement(
  t.Label,
  {
    ref: a,
    className: n(
      "px-2 py-1 text-xs font-semibold uppercase tracking-wider text-gray-700",
      r
    ),
    ...l
  }
));
u.displayName = t.Label.displayName;
const g = e.forwardRef(({ className: r, children: l, ...a }, o) => /* @__PURE__ */ e.createElement(
  t.Item,
  {
    ref: o,
    className: n(
      "relative flex w-full cursor-pointer select-none items-center justify-between rounded-sm p-2 text-sm text-gray-700 outline-none focus:bg-green-300 data-[disabled]:pointer-events-none data-[state=checked]:font-semibold data-[state=checked]:text-green-900 data-[disabled]:opacity-50",
      r
    ),
    ...a
  },
  /* @__PURE__ */ e.createElement(t.ItemText, null, l),
  /* @__PURE__ */ e.createElement("span", { className: "ml-2" }, /* @__PURE__ */ e.createElement(t.ItemIndicator, null, /* @__PURE__ */ e.createElement(s, { icon: "check", className: "size-3.5 shrink-0" })))
));
g.displayName = t.Item.displayName;
const f = e.forwardRef(({ className: r, ...l }, a) => /* @__PURE__ */ e.createElement(
  t.Separator,
  {
    ref: a,
    className: n("-mx-1 my-1 h-px bg-gray-100", r),
    ...l
  }
));
f.displayName = t.Separator.displayName;
export {
  N as Select,
  p as SelectContent,
  h as SelectGroup,
  g as SelectItem,
  u as SelectLabel,
  m as SelectTrigger,
  x as SelectValue,
  N as default
};
